/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { EdgeProps, getSmoothStepPath } from '@xyflow/react';

const CustomEdge: React.FC<any> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
}: EdgeProps<any>) => {
  // Generate the smooth step path
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 10, // Adjust this to change the smoothness
  });

  return (
    <>
      {/* Edge Path */}
      <path
        id={id}
        d={edgePath}
        markerEnd={markerEnd}
        style={{ stroke: '#B0B1B6', strokeWidth: 1, fill: 'none' }} // Adjust strokeWidth for better visibility
      />
    </>
  );
};

export default CustomEdge;
